export const messages = {
  title: 'Deine Vorteile',
  description:
    'Verkaufe dein Fahrzeug an ein breites Händlernetzwerk mit einer großen Anzahl von spezialisierten Marken- und freien Händlern. Alle Käufer wurden umfassend geprüft, alle Marken werden akzeptiert.',
  item1: 'Keine nervige Käufersuche',
  item2: 'Problemlose Abwicklung ohne Aufwand',
  item3: 'Kostenlose Abholung',
};

export const faqEntries = [
  {
    question: 'Was macht carsale24?',
    answer:
      'carsale24 ist eine sichere und bequeme Möglichkeit, dein Auto zu verkaufen. Egal ob bei der Erstellung des Fahrzeuginserats über die Preisverhandlungen mit potenziellen Käufern bis hin zum Abschluss eines verbindlichen Kaufvertrags. Je nach Wunsch kannst du zwischen dem kostenlosen Standard- oder dem kostenpflichtigen Premiumprozess wählen. Dein Fahrzeug wird überregional angeboten, und somit wird im Durchschnitt ein höherer Verkaufspreis für dich erzielt. Finanziert wird der carsale24-Service über eine geringe Provision, die von den Autohändlern beim Kauf eines Gebrauchtwagens gezahlt wird.',
  },
  {
    question: 'Wer bietet auf mein Fahrzeug?',
    answer:
      'Dein Fahrzeug wird vorher ausgewählten Händlern aus ganz Deutschland angeboten. carsale24 bietet für Gebrauchtwagenhändler die Möglichkeit, ihren Fahrzeugbestand schneller dem aktuellen Bedarf am Markt anzupassen. Neben freien Mehrmarkenhändlern gehören große Autohäuser ebenso zum Händlerpool von carsale24 wie kleinere Kfz-Servicebetriebe, die im Auftrag von Kunden ab und zu ein Fahrzeug kaufen. Alle Händler müssen ihren Händlerstatus nachweisen und werden von carsale24 geprüft. Unseriöse Händler werden von carsale24 sofort ausgesiebt.',
  },
  {
    question: 'Was kostet der carsale24-Service?',
    answer:
      'carsale24 ist in seiner Standard-Funktionalität komplett kostenlos. Da du keine Angebote unter deiner Preisvorstellung annehmen musst, ist carsale24 außerdem ohne Risiko - du allein entscheidest über den Verkauf. Auf Wunsch kannst du alternativ auch den Premium-Service für 179€ in Anspruch nehmen.',
  },
  {
    question: 'Wer sollte das Auto abmelden?',
    answer:
      'Sofern du dein Auto nicht schon abgemeldet hast oder dies selbst tun möchtest, erledigt der Käufer dies kostenlos für dich mit. carsale24 bietet optional die Abmeldung auch als Dienstleistung an.',
  },
  {
    question: 'Wie wird das Auto bezahlt?',
    answer:
      'Spätestens wenn der Abholtermin vereinbart ist, wird auch die Bezahlung festgelegt. Du entscheidest, ob direkt bar vor Ort bezahlt werden soll oder per Überweisung.',
  },
  {
    question: 'Was passiert, wenn die Kaufangebote nicht angenommen werden?',
    answer:
      'Eine Verkaufspflicht besteht nur, sofern deine Preisvorstellung erreicht wurde. Stellen die Kaufangebote eine erhebliche Differenz zu deiner Preisvorstellung bzw. zu einem realistischen Marktwert dar, bietet dir carsale24 selbstverständlich die Möglichkeit einer zweiten, kostenfreien Gebotsrunde für dein Fahrzeug.',
  },
  {
    question: 'Ist der Verkaufsprozess anonym?',
    answer:
      'Bis zum Abschluss des Kaufvertrages ist der Autoverkauf komplett anonym. So bleibst du von zwielichtigen Angeboten und dubiosen Anrufen verschont.',
  },
];
